import { Component, AfterContentInit, OnDestroy, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { TimerDTO, ValidationDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';

import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { SelectItem, TreeNode } from 'primeng-lts/api';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'validationsPanel',
  templateUrl: 'validationsPanel.template.html'
})
export class validationsPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {

  loaded = false;
  validations: ValidationDTO[] = [];

  selectedGroup: string;
  selectedType: string;

  groupedInfo: Array<TreeNode>;
  types: Array<SelectItem>;
  validationGroups: Array<SelectItem>;

  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    private plycaErrorHandler: PlycaErrorHandler,
    private elem: ElementRef
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.VALIDATIONS));
  }

  ngAfterContentInit(): void {


    this.headerActionsService.setTaskDescription(this.elem, 'validations.title', 'far fa-file-alt', true);

    this.subscribe(this.headerActionsService.addAction(
      'General.reload',
      'fas fa-sync-alt',
      'btn-secondary',
      true
    ), success => {
      this.loadValidations('');
    });
    this.headerActionsService.addDivider();

    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });
    this.loadValidations('');

  }


  loadValidations(validationGroup: string) {
    this.loaded = false;
    this.waitService.startWaiting();
    this.subscribe(this.plycaService.getValidations(validationGroup),
      (result: PaginationDTO<ValidationDTO>) => {
        if (result.content) {
          this.validations = result.content;
          this.loadTypes();
        }
        this.loaded = true;
        this.waitService.cancelWaiting();
      },
      (error) => {
        this.plycaErrorHandler.showServerError(error)
        this.loaded = true;
        this.waitService.cancelWaiting();
      });
  }

  loadTypes() {
    this.types = [];
    this.validations
      .map(validation => validation.type)
      .sort()
      .filter((value, index, self) => self.indexOf(value) === index)
      .forEach(element => {
        this.types.push({ label: element, value: element });
      });
    if (!this.selectedType) {
      this.selectedType = this.types[0].value;
    }
    this.loadValidationGroups();
  }

  selectType(selectedType: any) {
    console.log('selectedType', selectedType);
    this.loadValidationGroups();
  }

  loadValidationGroups() {
    this.validationGroups = [];
    this.validations
      .filter(validation => validation.type === this.selectedType)
      .map(validation => validation.identifier)
      .sort()
      .filter((value, index, self) => self.indexOf(value) === index)
      .forEach(element => {
        this.validationGroups.push({ label: element, value: element });
      });
    // inicializamos con el primer grupo
    this.selectValidationGroup(this.selectedGroup || this.validationGroups[0].value);
  }

  selectValidationGroup(selectedValidationGroup: any) {
    console.log('selectValidationGroup', selectedValidationGroup);
    this.groupInfo(selectedValidationGroup);
  }

  groupInfo(selectedValidationGroup: string) {
    console.log('groupInfo', this.selectedType, selectedValidationGroup);
    this.groupedInfo = this.validations2NodeArray(
      this.validations.filter(
        validation =>
          validation.type === this.selectedType &&
          validation.identifier === selectedValidationGroup
      )
    );
  }

  validations2NodeArray(validations: ValidationDTO[]) {
    if (validations) {
      let nodes: Array<TreeNode> = [];
      validations.forEach(validation => {
        let node = {
          data: validation,
          expanded: true,
          children: this.validations2NodeArray(validation.childrenValidations)
        };
        nodes.push(node);
      });
      return nodes;
    }
  }
}
